export default "__VITE_ASSET__BFxpTRUi__"